<template>
	<div class="popup">

        <div class="popup-header">
            <div v-if="profession.id > 0">
                {{profession.profession}}
            </div>
            <div v-else>
                 {{ $t("labels.newprofession") }}
            </div>
            <div v-if="profession.id == 0" class="popup-close" @click="$emit('close')">
                <font-awesome-icon icon="times" />
            </div>
            <div v-else class="popup-close" @click="save_and_close">
                <font-awesome-icon icon="times" />
            </div>
        </div>
        <div class="popup-body">
            <b-container>
                <form class="form" v-on:submit='save_and_close'>
                    <!-- branche name -->
                    <div class="form-row">
                        <div class="col-3">
                            <font-awesome-icon v-if="checkprofession" icon="check" style="color: green;"/>
                            <font-awesome-icon v-else icon="times" style="color: red;"/>                  
                            <label for="">{{ $t("labels.profession") }}</label>
                        </div>
                        <div class="col">
                            <b-input ref="deffield" :state="checkprofession" type="text" class="form-control" v-model="profession.profession"></b-input>
                            <b-form-invalid-feedback >
                                {{ $t("validation.professioncheck")}}
                            </b-form-invalid-feedback>  
                        </div>
                         
                    </div>
                </form>
            </b-container>
        </div>
        <div class="popup-footer">
            <div v-if="profession.id == 0" class="btn btn-primary" @click="my_add_profession();">{{ addprofessionText() }}</div>
            <div v-else @click="save_and_close" class="btn btn-primary">{{ $t("buttons.saveandclose") }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    name: 'profession-modal',
    data() {
        return {
            new_profession:{id:0, profession:""}
        }
    },
    props: {
        profession_id: Number
    },
    mounted() {
        this.focusInput();
    },
    computed: {
        profession() {
            return this.profession_id > 0 ? this.profession_by_id(this.profession_id) : this.new_profession
        },
        ...mapGetters([
            'profession_by_id',
        ]),
        ...mapState([
            'professions',
        ]),
        checkprofession(){
            if(this.profession.id>0){
                return true
            }
            let found=false;
            if(this.profession.profession!=undefined){
                for(var i=0;i<this.professions.length;i++){
                    if(this.profession.profession.toLowerCase()==this.professions[i].profession.toLowerCase()){
                        found = true;
                        break;
                    }
                }
            }
            return !found &&this.profession.profession!=undefined&& this.profession.profession.length>2
        }        
    },
    methods: {
        addprofessionText(){
            if (this.checkprofession){
                return this.$i18n.t("buttons.add") 
            } else { 
                return this.$i18n.t("buttons.invalid") 
            }
        },
        save_and_close(e) {
            e.preventDefault() // it prevent from page reload
            if(this.profession.id==0){
                this.my_add_profession()
            }else{
                this.save_profession(this.profession.id)
                this.$emit('close')
            }            
        },
        ...mapActions([
            'save_profession',
            'add_profession'
        ]),
        my_add_profession(){
            if(this.checkprofession){
                this.add_profession(this.profession);
                this.$emit('close')
            }
        },
    focusInput() {
      this.$refs.deffield.focus();
    }        

    }
}
</script>